import {ReactNode} from 'react'
import {addMaybeClassName} from '@freckle/educator-entities/ts/common/helpers/classnames'
import {
  popoverStyle,
  content,
} from './popover.module.scss'
import { H3 } from '../typography'

type Props = {
  id: string
  title?: string | null
  className?: string
  dataTest?: string | null
  /* Content of the Popover */
  children: ReactNode
}

export function Popover(props: Props) {
  const titleNode =
    props.title !== null && props.title !== undefined ? <H3>{props.title}</H3> : null
  const className = addMaybeClassName(popoverStyle, props.className)
  return (
    <div id={props.id} className={className} data-test={props.dataTest}>
      {titleNode}
      <div className={content}>{props.children}</div>
    </div>
  )
}